import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommandService} from '@core/services/command.service';
import {DialogService} from '@shared/services/dialog-service';
import {Store} from '@ngrx/store';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {TaskManagerState} from '../../store/task-manager.reducer';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {TaskManagerBoardTileComponent} from '../task-manager-board-tile/task-manager-board-tile.component';
import {MemberDialogModel, ShareItemService} from '@shared/services/share-item.service';
import {DeleteBoardCommand, RenameBoardCommand} from '../../commands/task-manager.command';
import {TaskManagerService} from '../../services/task-manager.service';
import {TaskManagerApiService} from '../../services/task-manager-api.service';
import {Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {DialogModel} from '@shared/models/dialog.model';
import {AddMemberToItemCommand} from '../../../../commands/contacts.command';
import {BoardOwner, NoAccess} from '../../constants/task-manager.constants';

@Component({
    standalone: false,
    selector: 'particle-task-manager-board-list',
  templateUrl: './task-manager-board-list.component.html',
  styleUrls: ['./task-manager-board-list.component.scss']
})
export class TaskManagerBoardListComponent extends TaskManagerBoardTileComponent implements OnInit, OnDestroy {
  sourceKey: string;
  invalidateSubject: InvalidateSubject;
  unSubscribe$ = new Subject<void>();

  constructor(protected dialog: MatDialog,
              protected router: Router,
              protected activatedRoute: ActivatedRoute,
              protected location: Location,
              protected taskManagerStore: Store<TaskManagerState>,
              protected securityStore: Store<SecurityState>,
              protected dialogService: DialogService,
              protected commandService: CommandService,
              protected queryStore: Store<IQueryState>,
              protected shareItemService: ShareItemService,
              protected taskManagerService: TaskManagerService,
              protected taskManagerApiService: TaskManagerApiService
  ) {
    super(dialog, router, activatedRoute, location, taskManagerStore, securityStore, dialogService, commandService, queryStore, taskManagerService, taskManagerApiService, shareItemService);
    this.sourceKey = 'BoardList';
    this.invalidateSubject = new InvalidateSubject();
  }

  getViewType() {
    return 'grid';
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }


  onGridCellValueChange(event) {
    console.log('-----', event);
    if (event.action) {
      switch (event.action.id) {
        case 'Open':
          this.openBoardInVirtualGrid(event.item);
          break;
        case 'Rename':
          this.renameBoardInVirtualGrid(event.item);
          break;
        case 'Members':
          this.openManageMembersDialogInVirtualGrid(event.item);
          break;
        case 'Delete':
          this.deleteBboardInVirtualGrid(event.item);
          break;
      }
      return;
    }
    if (event.fieldDefinition) {
      const item = event.item;
      switch (event.fieldDefinition.key) {
        case 'Title':
          this.openBoard(item);
          break;
        case 'Members':
          this.openManageMembersDialog(item);
          break;
      }
    }
  }

  private deleteBboardInVirtualGrid(board: any) {
    this.taskManagerApiService.getTicketCount(board.id, board.cells.Scope.value).pipe(takeUntil(this.unSubscribe$)).subscribe(x => {
      const confirmTxt = x === 0 ? 'Are you sure you want to delete?' : `This board has ${x} task(s).  Deleting it will also delete the task(s). Are you sure you want to delete this board and it's task(s)?`;
      this.dialogService.showYesNoDialog('Confirm Delete', confirmTxt).pipe().subscribe(state => {
        if (state && state.action === 'OK') {
          const command = new DeleteBoardCommand(board.id);
          this.commandService.executeCommand(command).pipe().subscribe(data => {
            this.taskManagerService.handleBoardsUpdate();
            this.invalidateSubject.invalidate();
          });
        }
      });
    });
  }

  private openBoardInVirtualGrid(item: any) {
    switch (item.cells.Type.value) {
      case 'OrbitaxSupport':
      case 'Support':
        this.navigateToSupportBoard();
        break;
      case 'Team':
        this.navigateToTeamBoard(item.id);
        break;
      case 'Personal':
        this.navigateToPersonalBoard(item.id);
        break;
    }
  }


  openManageMembersDialogInVirtualGrid(item) {
    const model = new MemberDialogModel();
    model.invalidateSubject = this.invalidateSubject;
    model.configKey = 'BoardMembersKey';
    model.itemId = item.id;
    model.metaData = {
      'BoardName': item.cells.Title.value
    };
    this.taskManagerApiService.getBoardMembersByBoard(item.id).pipe( take(2) ).subscribe(board => {
      if (board) {
        const selectedUsers = this.shareItemService.mapSelectedUsers(board.userGroups);
        const maxPermission = this.getMaxPermissionForBoard(selectedUsers, item);
        const contactsMetaData = {
          'selectedUsers': selectedUsers,
          'permissions': board.permissions.filter(p => p.permissionType <= maxPermission),
          'defaultPermission': this.defaultBoardPermission,
          'maxPermission': maxPermission
        };
        const command = new AddMemberToItemCommand('', item.id, [], model.metaData);
        this.shareItemService.showDialog(model, contactsMetaData, command);
      }
    });
  }

  renameBoardInVirtualGrid(item) {
    const dialogModel = DialogModel.create('Rename Board', 'AddBoardDialogComponent', {title: item.cells.Title.displayText});
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(state => {
      if (state && state.action === 'OK') {
        if (state.data.input.boardName !== '' && state.data.input.boardName !== item.cells.Title.displayText) {
          const command = new RenameBoardCommand(state.data.input.boardName, item.id);
          this.commandService.executeCommand(command).pipe().subscribe(data => {
            this.taskManagerService.handleBoardsUpdate();
            this.invalidateSubject.invalidate();
          });
        }
      }
      console.log(state);
    });
  }
}
